export const getInitialOptions = passedOptions => {
  return passedOptions
    .map(passedOption => (typeof passedOption === "object" ? passedOption : { label: passedOption, value: passedOption }))
    .filter(option => option !== null);
};
